import { collectAllMeasures, getMutableComponentProps } from "./utils";
const BENCHMARK_ID_PLACEHOLDER = "__BENCHMARK_ID__";
const NEW_BENCHMARK_WIDGET = "FndPeQuartileRankingNewBenchmark";
export const setupBenchmarkIdContext = (componentProps, allDependencies, originalComponentProps) => {
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    if (allDependencies.changeBenchmarkFundId) {
        mutableComponentProps.defaultFilters = {
            ...mutableComponentProps.defaultFilters,
            "Fund.FundId": [allDependencies.changeBenchmarkFundId]
        };
    }
    if (allDependencies.changeBenchmarkInvestmentId) {
        mutableComponentProps.defaultFilters = {
            ...mutableComponentProps.defaultFilters,
            // The Fund.InvestorId filter expects the value from the Investor.InvestorId datapoint
            "Fund.InvestorId": [allDependencies.changeBenchmarkInvestmentId]
        };
    }
    const isNewBenchmarkWidget = allDependencies.widgetId === NEW_BENCHMARK_WIDGET;
    const benchmarkId = isNewBenchmarkWidget
        ? allDependencies.selectedBenchmarkId
        : allDependencies.changeBenchmarkBenchmarkId;
    const measures = collectAllMeasures(mutableComponentProps);
    for (const measure of measures) {
        const context = measure.context;
        if (context?.benchmarkOverride?.benchmarkId === BENCHMARK_ID_PLACEHOLDER && benchmarkId) {
            context.benchmarkOverride.benchmarkId = benchmarkId;
        }
    }
    return mutableComponentProps;
};
